import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-selects-projects',
  templateUrl: './selects-projects.component.html',
  styleUrls: ['./selects-projects.component.scss']
})
export class SelectsProjectsComponent extends NgbActiveModal implements OnInit {

  public projects: Array<string>;
  public selected: Array<string> = [];

  constructor(
    public activeModal: NgbActiveModal
  ) {
    super();
  }

  ngOnInit() {
    this.projects = [
      'project 1',
      'project 2',
      'project 3',
      'project 4',
      'project 5',
      'project 6',
      'project 7',
      'project 8',
      'project 9',
      'project 10',
      'project 11',
      'project 12',
      'project 13',
      'project 14',
      'project 15',
      'project 16',
      'project 17',
      'project 18',
    ]
  }

  onSelect(project) {
    const found = this.selected.indexOf(project);
    if (found === -1) {
      this.selected.push(project);
    } else {
      this.selected.splice(found, 1);
    }
  }

  select() {
    this.activeModal.close(this.selected);
    this.selected = [];
  }
}
